module.exports = __webpack_public_path__ + "static/img/p5.5aa7783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/parkServices/p5.jpg
// module id = qYIj
// module chunks = 1